import React from 'react'

import * as Icons from '@desenvolvimento-intuix/ui-icons'

// eslint-disable-next-line no-unused-vars
import { IToastComponent, IVariant } from '../../interfaces/toast'

import { Container, Progress } from './styles'

export const Toast: React.FC<IToastComponent> = ({
  title,
  message,
  variant,
  timeout
}) => {
  const icons = {
    info: <Icons.Info />,
    success: <Icons.CheckCircle />,
    warning: <Icons.AlertTriangle />,
    error: <Icons.AlertOctagon />
  }

  const renderIcon = (variant: IVariant) => {
    return icons[variant]
  }

  return (
    <Container {...{ variant }} className='toast show'>
      <header>
        <i>{renderIcon(variant)}</i>

        {title && <strong>{title}</strong>}
      </header>

      {message && (
        <p
          dangerouslySetInnerHTML={{
            __html: message
          }}
        />
      )}

      <Progress {...{ variant, timeout }} />
    </Container>
  )
}
